/*
 * Copyright (c) 2021 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, January 2021
 */

import React, { useContext } from 'react';
import { Box, convertShorthand, styled } from '@staffino/primitive-controls';
import SettingsContext from './settings-context';

type WrapperBoxProps = {
  backgroundUrl?: string;
  cover?: boolean;
};
const WrapperBox = styled(Box)<WrapperBoxProps>((props: WrapperBoxProps) =>
  props.backgroundUrl
    ? {
        backgroundColor: 'transparent',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: props.cover ? 'cover' : 'auto',
        backgroundImage: `url(${props.backgroundUrl})`,
      }
    : {},
);

type Props = {
  margin?: string;
  padding?: string;
  background?: string | { url: string; cover?: boolean };
  children?: React.ReactNode;
};

function BlockWrapper({ margin, padding, children, background }: Props) {
  const { contentWidth } = useContext(SettingsContext);
  const backgroundUrl =
    typeof background === 'string' ? background : background?.url;
  const cover = typeof background === 'string' ? true : background?.cover;
  if (margin || padding) {
    const margins = convertShorthand('margin', margin);
    const paddings = convertShorthand('padding', padding);

    return (
      <WrapperBox
        width={contentWidth ?? '100%'}
        {...margins}
        {...paddings}
        backgroundUrl={backgroundUrl}
        cover={cover}
      >
        {children}
      </WrapperBox>
    );
  }

  return children;
}

export default BlockWrapper;
